import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import GlobalModal from '../../components/GlobalModal';
import { Creators as AppCreators } from '../../redux/reducers/app';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      modalRequest: AppCreators.modalRequest,
    },
    dispatch
  );

const mapStateToProps = ({ app }) => ({
  ...app.getIn(['modal']),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalModal);
